import { createAction } from 'redux-actions'
import { get, identity } from 'lodash/fp'
import { Action, ThunkAction } from '../types/common'
import { query } from '../common/api'
import {
  PUBLISHED_MESSAGE_QUERY,
  PUBLISH_MESSAGE_MUTATION,
  UPDATE_MESSAGE_MUTATION,
  ARCHIVE_MESSAGE_MUTATION,
} from './internalMessagesQueries'
import { IPublishedMessage } from '../types/message'

export const SET_PUBLISHED_MESSAGE = 'INTERNAL_MESSAGES/SET_PUBLISHED_MESSAGE'
export type SET_PUBLISHED_MESSAGE = Action<IPublishedMessage | null>
export const setPublishedMessage = createAction<
  IPublishedMessage | null,
  IPublishedMessage | null
>(SET_PUBLISHED_MESSAGE, identity)

export const requestPublishedMessage =
  (): ThunkAction<Promise<void>> => async (dispatch) => {
    const message = get(
      'publishedMessage',
      await query(PUBLISHED_MESSAGE_QUERY),
    )
    dispatch(setPublishedMessage(message))
  }

export const publishMessage =
  (content: string): ThunkAction<Promise<void>> =>
  async (dispatch) => {
    const result = get(
      'messagePublish.result',
      await query(PUBLISH_MESSAGE_MUTATION, { content }),
    )
    if (result) {
      dispatch(setPublishedMessage(result))
    }
  }

export const updateMessage =
  (id: number, content: string): ThunkAction<Promise<void>> =>
  async (dispatch) => {
    const result = get(
      'messageUpdate.result',
      await query(UPDATE_MESSAGE_MUTATION, { id, content }),
    )
    if (result) {
      dispatch(setPublishedMessage(result))
    }
  }

export const archiveMessage =
  (id: number): ThunkAction<Promise<void>> =>
  async (dispatch) => {
    const result = get(
      'messageArchive.result',
      await query(ARCHIVE_MESSAGE_MUTATION, { id }),
    )
    if (result) {
      dispatch(setPublishedMessage(null))
    }
  }
